'use client';

import useDelegateWalletMessage from 'src/components/DelegateWalletMessage/hooks/useDelegateWalletMessage';
import { UseDelegateWalletMessageParams } from 'src/components/DelegateWalletMessage/types';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';

export default function DelegateWalletMessage({
	inherited,
}: UseDelegateWalletMessageParams) {
	const delegateWalletMessage = useDelegateWalletMessage({ inherited });

	if (!delegateWalletMessage) {
		return null;
	}

	return <InlineAlert variant="info" title={delegateWalletMessage} />;
}
